import script from "./suggestLiveV2.vue?vue&type=script&setup=true&lang=js"
export * from "./suggestLiveV2.vue?vue&type=script&setup=true&lang=js"

import "./suggestLiveV2.vue?vue&type=style&index=0&id=73b73f6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73b73f6a"]])

export default __exports__